"use client";

import React, {useEffect} from "react";

export default function FireGtagEvent({name, payload = {}}: Readonly<{ name: string, payload: Object }>) {

  useEffect(() => {
    // @ts-ignore
    if (typeof window !== 'undefined' && window.gtag !== undefined) {
      // @ts-ignore
      window.gtag('event', name, payload);
    }
  }, [name, payload]);

  return (<></>);
}
